/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSpendBreakdownSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetSpendBreakdownRequest = {
  /**
   * Inclusive UTC midnight reporting boundary. Must be paired with to.
   */
  from?: Date | undefined;
  /**
   * Exclusive UTC midnight reporting boundary. Must be paired with from and no later than three calendar months after from, clamped to the target month's last day.
   */
  to?: Date | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetSpendBreakdownSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetSpendBreakdownSecurity$outboundSchema: z.ZodMiniType<
  GetSpendBreakdownSecurity$Outbound,
  GetSpendBreakdownSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSpendBreakdownSecurityToJSON(
  getSpendBreakdownSecurity: GetSpendBreakdownSecurity,
): string {
  return JSON.stringify(
    GetSpendBreakdownSecurity$outboundSchema.parse(getSpendBreakdownSecurity),
  );
}

/** @internal */
export type GetSpendBreakdownRequest$Outbound = {
  from?: string | undefined;
  to?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetSpendBreakdownRequest$outboundSchema: z.ZodMiniType<
  GetSpendBreakdownRequest$Outbound,
  GetSpendBreakdownRequest
> = z.pipe(
  z.object({
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getSpendBreakdownRequestToJSON(
  getSpendBreakdownRequest: GetSpendBreakdownRequest,
): string {
  return JSON.stringify(
    GetSpendBreakdownRequest$outboundSchema.parse(getSpendBreakdownRequest),
  );
}
